import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { ASSET_BASE_PATH } from '../../../../features/asset/asset-routing';

// This route exists just to provide breadcrumbs for the securities subpages.
export const Route = createFileRoute('/_app/_clearing-core/asset/_asset')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'assets',
        label: 'Assets',
        to: ASSET_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
